export default __webpack_public_path__ + "static/media/LogoIcon.d0121582.png";